<!-- Grid Responsive Layout -->
<mat-grid-list cols="1" rowHeight="100vh" [style.background]="'#1E2122'">
  <mat-grid-tile>
    <mat-card class="rh_login_container">
      <ng-container *ngTemplateOutlet="loginContent; context: { errorMessage }"></ng-container>
    </mat-card>
  </mat-grid-tile>
</mat-grid-list>

<!-- Login Content -->
<ng-template #loginContent let-errorMessage="errorMessage">
  <div class="rh_login_content">
    <img
      class="rh_login_logo"
      [src]="'/assets/images/RHAPSODY KEY MANAGEMENT.svg'"
      alt="API Keys Logo"
    />
    <span class="mat-body-small"
      >Login with your Rhapsody User Community Account</span
    >
    <button class="rh_login_btn" mat-flat-button (click)="loginAction.emit()">
       LOGIN
    </button>

    <div *ngIf="errorMessage">
      <pre><strong>Error: {{errorMessage}}</strong></pre>
      <span class="mat-body">
"No code in URL" indicates that your user does not have access to the Rhapsody Authorization Service OneLogin application</span>
    </div>
  </div>
</ng-template>
